<template>
  <div class="index">
    <div class="content">
      <div class="about">
        <div class="about-left">
          <img
            src="../../assets/image/about.png"
            alt=""
          >
        </div>
        <div class="about-right">
          <div class="text">
            甘肃省融资担保集团股份有限公司（简称“担保集团”）成立于2012年2月，注册资本50亿元，是由甘肃省公路航空旅游投资集团有限公司、甘肃省金融资本管理有限公司出资设立的省内资本规模最大、担保实力最强的市场化国有担保机构。连续5年获得中诚信国际、联合资信、东方金诚等6家市场权威评级机构授予的行业最高等级——AAA主体信用评级，增信实力位居全国担保行业第一梯队。
          </div>
          <div class="text">
            担保集团始终践行服务实体经济的初心使命，在服务大局中彰显国企担当，持续为区域经济的繁荣发展贡献担保力量，获得了政府、行业、客户的广泛高度认可。曾获得由国家工信部、财政部专项奖补资金6000万元，额度位居全国同行业第一；先后八次荣获“省长金融奖”，在全国担保行业开展的优秀担保机构评选活动中，被评为“最具影响力担保机构”和“最具创新力担保机构”；自主研发的“增信保”产品在第二届“陇上金融家”评选活动中荣获“甘肃最佳金融产品和服务”奖项。
          </div>
          <div class="text">
            担保集团内设11个部门，下设4家子公司和10家分公司，业务机构覆盖甘肃全省，并在陕西省设立省外机构。自成立以来，与多家头部券商、大型投资机构建立了良好合作关系，累计为1万余户市场主体提供各类融资服务近680亿元。债券担保业务立足甘肃、辐射全国，业务布局已覆盖陕、川、渝、苏、湘、鄂、鲁等地；持续强化金融科技赋能，成功签发省内首笔电子投标保函，非融保函业务市场占有率稳居省内第一；以专业、高效的金融服务赢得业界赞誉，品牌影响力不断提升。
          </div>

         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.index{
    display: flex;
    flex-direction: column;
    height: 780px;
    background-color: #f2f2f2;
}
.content {
  width: 1200px;
  height: 700px;
  margin: 0 auto;
  background: #ffff;
  margin-top: 50px;
}
.about {
    display: flex;
    justify-content: center;
    padding-top: 60px;
    .about-left {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      }
    }
    .about-right {
      position: relative;
      .text {
        text-align:justify;
        margin-left: 100px;
        width: 670px;
        text-indent: 2em;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666;
        line-height: 36px;
      }
      ::v-deep .ant-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 96px;
        height: 40px;
        border: 1px solid #ddd;
        border-radius: 20px;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999;
        background-color: #fff;
        cursor: pointer;
        transition: all 0.5s;
      }
    }
  }
</style>
